import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/utils";
import { Overline } from "@repo/ui/overline";
import { Actions } from "@/components/common/actions/actions.component";
import { RichTextBodyCopySimple } from "@/components/common/rich-text/rich-text-body-copy-simple.component";
import type { BodySimpleVerticalProps } from "./body-simple-vertical.types";
export function BodySimpleVertical(t0) {
  const $ = _c(18);
  const {
    overline,
    headline,
    body,
    actions,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("bg-surface-base-primary", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== overline) {
    t2 = overline && <Overline>{overline}</Overline>;
    $[2] = overline;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== headline) {
    t3 = headline && <h2 className="typography-mobile-heading-h5 desktop:typography-desktop-heading-h5 text-text-primary">{headline}</h2>;
    $[4] = headline;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== body) {
    t4 = body && <RichTextBodyCopySimple richText={body} className="text-text-secondary" />;
    $[6] = body;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== actions) {
    t5 = actions && actions.length > 0 && <Actions actions={actions} className="mt-2" />;
    $[8] = actions;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <div className="container-grid py-16 desktop:py-20"><div className="col-span-full grid grid-cols-subgrid"><div className="col-span-full tablet:col-span-4 desktop:col-span-6 flex flex-col gap-6 desktop:gap-10">{t2}{t3}{t4}{t5}</div></div></div>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t1 || $[16] !== t6) {
    t7 = <section className={t1} data-testid="body-simple-vertical">{t6}</section>;
    $[15] = t1;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}